const Style = ({ attributes, clientId }) => {
	const { textAlign, background, padding, prefixTypo, prefixColor, typingContentsTypo, suffixTypo, suffixColor } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${prefixTypo?.googleFontLink ? `@import url(${prefixTypo?.googleFontLink});` : ''}
		${typingContentsTypo?.googleFontLink ? `@import url(${typingContentsTypo?.googleFontLink});` : ''}
		${suffixTypo?.googleFontLink ? `@import url(${suffixTypo?.googleFontLink});` : ''}

		#ttbTextTyping-${clientId} .ttbTextTyping{
			text-align: ${textAlign};
			${background?.styles || 'background-color: #0000;'}
			padding: ${padding?.styles || '10px 15px'};
		}
		#ttbTextTyping-${clientId} .ttbTextTyping .prefixText{
			color: ${prefixColor};
			${prefixTypo?.styles || 'font-size: 22px;'}
		}
		#ttbTextTyping-${clientId} .ttbTextTyping .typingContents, #ttbTextTyping-${clientId} .ttbTextTyping .typed-cursor{
			${typingContentsTypo?.styles || 'font-size: 22px; font-weight: 600;'}
		}
		#ttbTextTyping-${clientId} .ttbTextTyping .suffixText{
			color: ${suffixColor};
			${suffixTypo?.styles || 'font-size: 22px;'}
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;